'use client';

import {
  GraduationCap,
} from '@phosphor-icons/react';
import { useTranslations } from 'next-intl';
import { trackEvent } from '@/lib/analytics/matomo';

interface DogSchoolBannerProps {
  className?: string;
}

export default function DogSchoolBanner({ className = '' }: DogSchoolBannerProps) {
  const t = useTranslations('landing.dogSchools');

  return (
    <section
      id="dog-schools"
      className={`py-16 sm:py-20 px-4 sm:px-6 lg:px-8 bg-amber-light ${className}`}
      aria-labelledby="dog-school-heading"
    >
      <div className="max-w-3xl mx-auto text-center">
        <div className="w-12 h-12 bg-amber/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <GraduationCap weight="regular" className="w-6 h-6 text-amber" />
        </div>

        <h2
          id="dog-school-heading"
          className="font-heading text-2xl sm:text-3xl font-semibold text-dark mb-3"
        >
          {t('heading')}
        </h2>

        <p className="text-gray-600 leading-relaxed mb-8 max-w-2xl mx-auto">
          {t('description')}
        </p>

        <div className="text-sm text-gray-600 leading-relaxed space-y-2 mb-8 max-w-xl mx-auto">
          <p>{t('details')}</p>
        </div>

        <a
          href="mailto:hello@vetta.health"
          className="inline-block px-8 py-3 bg-dark hover:bg-dark-surface text-white font-heading font-semibold rounded-brand transition-colors"
          onClick={() => trackEvent('landing', 'dog_school_cta_click')}
        >
          {t('cta')}
        </a>
      </div>
    </section>
  );
}
